$(".burger-container").click(function() {
    if($(".icon-title:visible").length){
        $(".sidebar-v2 .icon-title").hide();
        $(".sidebar-v2").addClass("closed");
    } else {
        $(".sidebar-v2 .icon-title").show();
        $(".sidebar-v2").removeClass("closed");
    }
});
